import React, { use, useEffect, useState } from 'react';
import { Container, Table, Spinner, ProgressBar } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import useAxios from 'axios-hooks';
import { useStateValue } from '../state';
import { fetchCurrentDate } from '../Api/date';
import moment from 'moment-timezone';

function Capacity() {
  const [isOffline, setIsOffline] = useState(false);
  const [{ date, locationId, roles }, dispatch] = useStateValue();

  const selectedDate = date.format('YYYY-MM-DD');
  const isToday = date.isSame(moment());
  const history = useHistory();
  const [spinner, setSpinner] = useState(false);

  // const [LocationId, setLocationId] = useState();
  // useEffect(() => {
  //   setLocationId(locationId);
  // }, [locationId]);

  const [{ data: getRemaining, loading: loadingRemaining, error: errorRemaining }, refetchRemaining] = useAxios(
    `${process.env.REACT_APP_BOOKING_APP_API_URL}/driver/checkins/${locationId}/${selectedDate}`,
    { useCache: false, deps: [locationId, selectedDate] },
  );

  const [{ data: getCapacity, loading, error }, refetch] = useAxios(
    `${process.env.REACT_APP_AVAILABILITY_SERVER_URL}/api/v1/dateRule/date/${selectedDate}/locationId/${locationId}`,
    { useCache: false, deps: [locationId, selectedDate] },
  );

  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const handleVisibilityChange = () => {
      try {
        const visible = document.visibilityState === 'visible';
        setIsVisible(visible);
        if (visible) {
          refetch();
        }
      } catch (error) {
        console.error('Error during refetch:', error);
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [refetch]);

  useEffect(() => {
    const handleOnline = async () => {
      setIsOffline(false);
      setTimeout(async () => {
        try {
          await refetch();
          await refetchRemaining();
        } catch (error) {
          console.error('Error refetching data on reconnect:', error);
        }
      }, 2000);
    };

    const handleOffline = () => {
      setIsOffline(true);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [refetch, refetchRemaining]);

  useEffect(() => {
    if (getRemaining) {
      dispatch({ type: 'UPDATE_GET_REMAINING', payload: getRemaining });
    }
  }, [getRemaining, dispatch]);

  useEffect(() => {
    if (getRemaining) {
      dispatch({ type: 'UPDATE_GET_REMAINING', payload: getRemaining });
    }
  }, [getRemaining, dispatch]);

  useEffect(() => {
    let isCancelled = false;

    const poll = async () => {
      try {
        if (!isCancelled && isVisible) {
          await refetch();
          await refetchRemaining();
          setTimeout(poll, 60000);
        }
      } catch (error) {
        console.error('Error during polling:', error);
      }
    };

    poll();

    return () => {
      isCancelled = true;
    };
  }, [refetch, refetchRemaining, isVisible]);

  const totalCheckins = getRemaining?.Total ?? 'None';
  const checkedIn = getRemaining?.Checkedin ?? 0;
  const left = totalCheckins !== 'None' ? totalCheckins - checkedIn : 0;

  const updateData = async (val) => {
    await dispatch({ type: 'changeLocation', id: val });
    const currentDateStr = await fetchCurrentDate(val);
    const newDate = moment(currentDateStr, 'YYYY-MM-DD HH:mm:ss');
    if (newDate.isValid()) {
      dispatch({ type: 'changeDate', newDate });
    } else {
      console.error('Fetched date is invalid:', currentDateStr);
    }
  };

  const formatTime = (checkin_time) => {
    const hours = checkin_time?.hours ?? 0;
    const minutes = checkin_time?.minutes ?? 0;
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  };

  if (loading || loadingRemaining) {
    return (
      <div className="text-center">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }
  const reloadData = () => {
    setSpinner(true);

    setTimeout(() => {
      refetch();
      refetchRemaining();
      setSpinner(false);
    }, 1000);
  };

  let errorMsg = '';
  if (isOffline)
    errorMsg =
      "You're offline. Please check your internet connection. Data will automatically refresh once you're back online.";
  if (error || errorRemaining) {
    const status = error?.response?.status || errorRemaining?.response?.status;
    var isNetworkError =
      (error && error.message === 'Network Error') || (errorRemaining && errorRemaining.message === 'Network Error');

    if (status === 404) {
      errorMsg = 'No programmed availability for this date. Please check the desktop version for updates.';
    } else if (isNetworkError) {
      errorMsg =
        "You're offline. Please check your internet connection. Data will automatically refresh once you're back online.";
    } else {
      errorMsg = 'Something went wrong. Please try again later.';
    }
  }

  return (
    <div>
      {error || errorRemaining || isOffline ? (
        <div className="px-3 py-3 ">
          <div className="px-3 py-3 d-flex justify-content-center">{errorMsg}</div>
          {(isOffline || isNetworkError) && !spinner && (
            <div className="d-flex justify-content-center">
              <button className="btn btn-primary " onClick={() => reloadData()}>
                Reload
              </button>
            </div>
          )}
          {spinner && (
            <div className="d-flex justify-content-center">
              <Spinner animation="border" variant="primary" />
            </div>
          )}
        </div>
      ) : (
        <div>
          <div className="text-center">
            <span className="subtitle-dark">
              {/* <b>{locationId === 1 ? 'LV:' : locationId === 2 ? 'OS:' : locationId === 5 ? 'HI:' : ''} </b> */}
              {/* Total = <b>{totalCheckins}</b> */}
              <div className="d-flex justify-content-center" style={{ gap: '1rem' }}>
                {/* <p>
                  Total= <b>{getRemaining.total} </b>
                </p> */}
                <p>
                  Complete= <b>{getRemaining.completed}</b>
                </p>
                <p>
                  Checked in= <b>{getRemaining.checkedIn}</b>
                </p>
                <p>
                  Manifested= <b>{getRemaining.manifested}</b>
                </p>
                <p>
                  Pending={' '}
                  <b>
                    {getRemaining.total - (getRemaining.checkedIn + getRemaining.manifested + getRemaining.completed)}
                  </b>
                </p>
              </div>
            </span>
            {isToday && (
              <div className="subtitle-dark d-inline">
                | Checked: <b>{checkedIn}</b> | Left: <b>{left}</b>
              </div>
            )}
          </div>

          <Container className="mt-3 mb-5 main-wrapper" id="trip-list">
            <Table hover size="sm">
              <thead>
                <tr>
                  <th>Check-in</th>
                  <th>Max</th>
                  <th>Booked</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {getCapacity?.slots?.map((slot, idx) => (
                  <React.Fragment key={idx}>
                    <tr>
                      <td>{formatTime(slot.checkin_time)}</td>
                      <td>{slot.number_of_spaces}</td>
                      <td>{slot.bookings}</td>
                      <td>
                        <div className="lock-icon" style={{ backgroundColor: slot.lock_status }}></div>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="4">
                        <ProgressBar
                          now={slot.is_orphaned ? 100 : (slot.bookings * 100) / slot.number_of_spaces + 1}
                          variant={slot.is_orphaned ? 'danger' : 'primary'}
                          style={{ height: '5px' }}
                        />
                      </td>
                    </tr>
                  </React.Fragment>
                ))}
              </tbody>
            </Table>
          </Container>
        </div>
      )}
      {(roles.includes('Manager') || roles.includes('Super Admin')) && (
        <div className="bottom-menu d-flex justify-content-around">
          <button
            style={{ marginRight: '1px' }}
            className={`btn button-large-third ${locationId === 1 ? 'button-large-third--active' : ''}`}
            onClick={() => updateData(1)}>
            Las Vegas
          </button>
          <button
            style={{ marginRight: '1px', marginLeft: '1px' }}
            className={`btn button-large-third ${locationId === 2 ? 'button-large-third--active' : ''}`}
            onClick={() => updateData(2)}>
            Oceanside
          </button>
          <button
            style={{ marginRight: '1px', marginLeft: '1px' }}
            className={`btn button-large-third ${locationId === 5 ? 'button-large-third--active' : ''}`}
            onClick={() => updateData(5)}>
            Hawaii
          </button>
          <button
            style={{ marginLeft: '1px' }}
            className={`btn button-large-third ${locationId === 7 ? 'button-large-third--active' : ''}`}
            onClick={() => updateData(7)}>
            New York
          </button>
        </div>
      )}
    </div>
  );
}

export default Capacity;
